export const MOTION_GRAPHICS_COLLECTION = 'motiongraphics.v2';
export const MOTION_GRAPHICS_CATEGORIES = 'motiongraphicstyles';
export const PAGE_REDIRECTS = 'pageredirects';

export const SFX_COLLECTION = 'sfx.v3';
export const SFX_COLLECTION_WITH_ENGAGEMENT = 'sfxWithEngagement';
export const TRENDING_SFX_COLLECTION = 'sfxTrending';
export const SFX_CATEGORIES = 'sfxstyles';
export const SFX_TAGS = 'sfxtags';
export const SFX_COLLECTIONS = 'sfxcollections';
export const SFX_QUALIFIED_KEYWORDS = 'sfxqualifiedkeywords';

// The collection name, not the `tracksV4` alias: Typesense echoes the real name
// in `request_params.collection_name`, which global search keys results by.
// Rollback is setting this back to 'tracks.v3'.
export const MUSIC_COLLECTION = 'tracks.v4';
export const TRACK_ENGAGEMENT_COLLECTION = 'trackEngagementV1';
export const TRENDING_MUSIC_COLLECTION = 'tracksTrending';
export const MUSIC_CATEGORIES = 'trackstyles';
export const MUSIC_TAGS = 'tracktags';
export const MUSIC_CONTRIBUTORS = 'artists';
export const MUSIC_COLLECTIONS = 'collections';
export const MUSIC_QUALIFIED_KEYWORDS = 'trackqualifiedkeywords';

export const SEARCH_REDIRECTS = 'search_redirects';

export const STOCK_VIDEO_COLLECTION = 'videos.v1';
export const STOCK_VIDEO_ENGAGEMENT_COLLECTION = 'videoEngagementV1';
export const STOCK_VIDEO_CATEGORY_GROUPS = 'videoCategoryGroups.v1';
export const STOCK_VIDEO_CATEGORIES = 'videoCategories.v1';

export const CONTRIBUTORS_COLLECTION = 'contributors.v1';
